import { store } from '../../components/Store';
import { findAContractorReducer } from '../connectors/FindAContractorConnector';

export default function FindAContractorStore(props) {
  const initialState = props;

  // Create a noOpReducer for location if it's not already in the store
  const noOpReducer = initial => (state = initial || null) => state;

  // Define the findAContractor reducer with the initial state from props
  const findAContractorWithState = (
    // eslint-disable-next-line default-param-last
    state = initialState.findAContractor,
    action
  ) => findAContractorReducer(state, action);

  // Inject the findAContractor reducer into the common store
  store.injectReducer('findAContractor', findAContractorWithState);

  // Check if we need to inject the location reducer
  if (initialState.location && !store.getState().location) {
    store.injectReducer('location', noOpReducer(initialState.location));
  }

  // Dispatch the initialization action
  store.dispatch({ type: 'FindAContractor/init' });

  // Return the common store instead of creating a new one
  return store;
}
